function dateIsInSameMonth(date) {
  const currDate = new Date();

  return (
    date.getFullYear() === currDate.getFullYear() &&
    date.getMonth() === currDate.getMonth()
  );
}

function dateIsInSameWeek(date) {
  let nextWeek = date.getTime() + 7 * 24 * 60 * 60 * 1000;
  return nextWeek > new Date().getTime();
}

function dateIsInSameDay(date) {
  const currDate = new Date();

  return dateIsInSameMonth(date) && date.getDate() === currDate.getDate();
}

export function dateIsInTimePeriod(date, period) {
  switch (period) {
    case "day":
      return dateIsInSameDay(date);

    case "week":
      return dateIsInSameWeek(date);

    case "month":
      return dateIsInSameMonth(date);

    default:
      return dateIsInSameDay(date);
  }
}
